import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import muiTheme from './muiTheme';
import { ToastProvider } from '../components/Toast';

/**
 * Root theme wrapper — MUI ThemeProvider + CssBaseline + Toast.
 * StyledEngineProvider injectFirst lets MUI styles override Bootstrap during migration.
 */
export function AppThemeProvider({ children }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <ToastProvider>{children}</ToastProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export { default as muiTheme } from './muiTheme';
export { default as useAppTokens } from './useAppTokens';
export {
  default as tokens,
  colors,
  typography,
  spacing,
  spacingUnit,
  radii,
  shadows,
  layout,
  zIndex,
  transitions,
} from './tokens';
